import { useEffect, useState } from "react";
import { MainLayout } from "@/components/MainLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { authAPI, User } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { isStudentPreview } from "@/lib/studentPreview";

export default function Perfil() {
    const navigate = useNavigate();
    const [user, setUser] = useState<User | null>(null);

    useEffect(() => {
        const currentUser = authAPI.getCurrentUser();
        if (!currentUser) {
            navigate("/login");
            return;
        }
        setUser(currentUser);
    }, [navigate]);

    const getInitials = (name?: string) => {
        if (!name) return 'U';
        return name
            .split(' ')
            .map(n => n[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    if (!user) return null;

    return (
        <MainLayout userType={isStudentPreview() ? 'aluno' : user.tipo_usuario === 'admin' ? 'admin' : 'aluno'} userName={user.nome}>
            <div className="space-y-6 max-w-4xl mx-auto">
                <div>
                    <h1 className="text-3xl font-bold">Meu Perfil</h1>
                    <p className="text-muted-foreground mt-1">
                        Gerencie suas informações pessoais e configurações
                    </p>
                </div>

                <Card>
                    <CardHeader>
                        <CardTitle>Informações do Usuário</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-6">
                        <div className="flex items-center gap-6">
                            <Avatar className="h-24 w-24">
                                <AvatarImage
                                    src={user.foto ? `${import.meta.env.VITE_API_URL || '/api'}${user.foto}` : undefined}
                                    alt={user.nome}
                                />
                                <AvatarFallback className="text-2xl bg-primary/10">
                                    {getInitials(user.nome)}
                                </AvatarFallback>
                            </Avatar>
                            <div>
                                <h3 className="text-2xl font-semibold">{user.nome} {user.sobrenome}</h3>
                                <p className="text-muted-foreground">{user.email}</p>
                                <span className="inline-flex mt-2 items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary">
                                    {user.tipo_usuario.charAt(0).toUpperCase() + user.tipo_usuario.slice(1)}
                                </span>
                            </div>
                        </div>

                        <div className="pt-6 border-t">
                            <p className="text-sm text-muted-foreground">
                                A edição de perfil está sendo implementada. Por enquanto, se você é um administrador, pode editar seus dados na tela de Gerenciar Usuários.
                            </p>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </MainLayout>
    );
}
